"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Star_1 = require("../Icons/Star/Star");
var StarRatingGroup_1 = __importDefault(require("../StarRatingGroup/StarRatingGroup"));
var Typography_1 = __importStar(require("../Typography/Typography"));
var b2c_theme_1 = require("../Theme/b2c-theme");
var RatingsSummaryElement = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var SubHeading = (0, styled_components_1.default)(Typography_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 0 0 2.4rem;\n"], ["\n  margin: 0 0 2.4rem;\n"])));
var RatingsSummary = function (_a) {
    var averageReviewText = _a.averageReviewText, ratingCounts = _a.ratingCounts, totalReviewsText = _a.totalReviewsText;
    return (react_1.default.createElement(RatingsSummaryElement, { "data-testid": "ratings-summary" },
        react_1.default.createElement(Typography_1.default, { align: "left", variant: Typography_1.TypeVariants.h3, theme: "primary" }, totalReviewsText),
        react_1.default.createElement(SubHeading, { align: "left", variant: Typography_1.TypeVariants.body, component: Typography_1.TypeVariants.h4 }, averageReviewText),
        ratingCounts.map(function (ratingCount, index) { return (react_1.default.createElement(StarRatingGroup_1.default, { activeStars: 5 - index, iconSpacing: Star_1.IconSpacingSizes.small, iconSize: b2c_theme_1.IconSizes.small, includeRatingCount: true, key: "".concat(index).concat(ratingCount), ratingCount: ratingCount })); })));
};
exports.default = RatingsSummary;
var templateObject_1, templateObject_2;
//# sourceMappingURL=RatingsSummary.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/@urbanmassage/component-library/lib/RatingsSummary/RatingsSummary.js
// module id = 1767
// module chunks = 5 16 19